import React from 'react';
import { ThunderboltOutlined, ControlOutlined, CheckOutlined, DownOutlined } from '@ant-design/icons';

const methods = [
  {
    id: 'quick',
    icon: <ThunderboltOutlined />,
    title: 'Quick Select',
    badge: 'Fastest',
    badgeColor: '#e6f7ff',
    badgeTextColor: 'var(--ink)',
    description: 'Choose from pre-built high-impact segments for fast campaign setup',
  },
  {
    id: 'custom',
    icon: <ControlOutlined />,
    title: 'Custom Audience',
    badge: 'Most Control',
    badgeColor: '#f0f0f0',
    badgeTextColor: '#666',
    description: 'Build a custom audience with advanced filters from your CRM data',
  },
];

const SelectAudienceMethod = ({ selectedMethod, onUpdate, onNext, channel }) => {
  const handleSelect = (methodId) => {
    onUpdate(methodId);
  };

  const handleContinue = () => {
    if (selectedMethod) {
      onNext();
    }
  };

  const getMethodLabel = () => {
    if (!selectedMethod) return 'Choose audience method';
    const method = methods.find(m => m.id === selectedMethod);
    return method ? `Method: ${method.title}` : 'Choose audience method';
  };

  // Get channel-specific wording
  const getChannelLabel = () => {
    if (channel === 'email') return 'Email';
    if (channel === 'sms') return 'SMS';
    return 'Campaign';
  };

  return (
    <div className="step-container">
      <h1 className="step-title">How Would You Like to Select Your {getChannelLabel()} Audience?</h1>
      <p className="step-subtitle">Choose a quick pre-built segment or build a custom audience from your CRM data</p>

      <div className="audience-method-grid">
        {methods.map((method) => {
          const isSelected = selectedMethod === method.id;
          return (
            <div
              key={method.id}
              className={`audience-method-card ${isSelected ? 'selected' : ''}`}
              onClick={() => handleSelect(method.id)}
            >
              {isSelected && (
                <div className="method-check">
                  <CheckOutlined />
                </div>
              )}
              <div className="method-icon" style={{ background: isSelected ? '#1a1a2e' : '#f5f5f5' }}>
                {React.cloneElement(method.icon, { style: { color: isSelected ? '#fff' : '#666' } })}
              </div>
              <div className="method-content">
                <div className="method-title-row">
                  <span className="method-title">{method.title}</span>
                  <span 
                    className="method-badge"
                    style={{ 
                      background: method.badgeColor, 
                      color: method.badgeTextColor 
                    }}
                  >
                    {method.badge}
                  </span>
                </div>
                <p className="method-description">{method.description}</p>
              </div>
            </div>
          );
        })}
      </div>

      {/* Footer */}
      <div className="campaign-footer">
        <div className="footer-info">
          {getMethodLabel()}
        </div>
        <button 
          className="continue-btn" 
          onClick={handleContinue}
          disabled={!selectedMethod}
        >
          Continue
          <DownOutlined />
        </button>
      </div>
    </div>
  );
};

export default SelectAudienceMethod;
